import { computed, Injectable, signal } from "@angular/core";
import { RequestStateModel } from "../Dto/RequestStateModel";
import { RequestEntity } from "../Dto/RequestModel";
import { PaginationInfo } from "../Dto/RequestSearchResponse";
import { RequestSearchRequest } from "../Dto/RequestSearchRequest";

const initialState: RequestStateModel = {
  data: [],
  pagination: { page: 1, limit: 10, total: 0, pages: 0 },
  searchParams: { page: 1, limit: 10 },
  loading: false,
  error: null,
};

@Injectable({ providedIn: "root" })
export class RequestState {
  private readonly state = signal<RequestStateModel>(initialState);

  public readonly data = computed(() => this.state().data);
  public readonly pagination = computed(() => this.state().pagination);
  public readonly searchParams = computed(() => this.state().searchParams);
  public readonly loading = computed(() => this.state().loading);
  public readonly error = computed(() => this.state().error);

  setRequests(data: RequestEntity[], pagination: PaginationInfo): void {
    this.state.update((state) => ({ ...state, data, pagination, loading: false, error: null }));
  }

  setSearchParams(params: RequestSearchRequest): void {
    this.state.update((state) => ({ ...state, searchParams: params }));
  }

  setLoading(loading: boolean): void {
    this.state.update((state) => ({ ...state, loading }));
  }

  setError(error: string | null): void {
    this.state.update((state) => ({ ...state, error }));
  }

  addRequest(entity: RequestEntity): void {
    this.state.update((state) => ({
      ...state,
      data: [entity, ...state.data],
      pagination: { ...state.pagination, total: state.pagination.total + 1 },
    }));
  }

  updateRequest(entity: RequestEntity): void {
    this.state.update((state) => ({
      ...state,
      data: state.data.map((item) =>
        (() => {
          if (item.id === entity.id) {
            return entity;
          }
          return item;
        })(),
      ),
    }));
  }

  removeRequest(id: string): void {
    this.state.update((state) => ({
      ...state,
      data: state.data.filter((item) => item.id !== id),
      pagination: { ...state.pagination, total: Math.max(0, state.pagination.total - 1) },
    }));
  }
}
